import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

export let startCanvasSupportDashboard = (
  nestedGroupData,
  groups,
  acts,
  nestedMyedGroups,
  myedGroups,
  myedActs,
  courseTitle,
  coursenum,
  applyGroupWeights
) => {
  ReactDOM.render(
    <App
      nestedGroupData={nestedGroupData}
      groups={groups}
      acts={acts}
      nestedMyedGroups={nestedMyedGroups}
      myedGroups={myedGroups}
      myedActs={myedActs}
      courseTitle={courseTitle}
      coursenum={coursenum}
      applyGroupWeights={applyGroupWeights}
    />,
    document.getElementById('canvasSupportDashboardApp')
  )
}
